import React, { useCallback, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useQuery } from 'js/hooks/useQuery';
import { listCapabilitySetUsedElementKeys } from 'js/actions/capability-actions';
import CapabilitySetForm from '../CapabilitySetForm';
import CapabilitySetThresholdsForm from './CapabilitySetThresholdsForm';

function CapabilitySetSettings({ capabilitySet, onUpdate }) {
  const dispatch = useDispatch();
  const capabilitySetId = capabilitySet?.id;
  const queryId = `capability-set-used-element-keys-${capabilitySetId}`;

  const queryUsedElementKeys = useCallback(
    (id) => dispatch(listCapabilitySetUsedElementKeys(capabilitySetId, id)),
    [dispatch, capabilitySetId]
  );

  const { refresh, result: usedElementKeys } = useQuery({
    queryId,
    query: queryUsedElementKeys,
  });

  useEffect(() => {
    if (capabilitySetId) {
      refresh();
    }
  }, [capabilitySetId, refresh]);

  return (
    <>
      <Card>
        <CardBody>
          <CapabilitySetForm
            capabilitySet={capabilitySet}
            onSubmit={onUpdate}
            submitLabel="Update"
            showCancel={false}
          />
        </CardBody>
      </Card>
      <Card className="mt-3">
        <CardBody>
          <h5>Thresholds</h5>
          <CapabilitySetThresholdsForm
            capabilitySet={capabilitySet}
            usedElementKeys={usedElementKeys || []}
            onSubmit={onUpdate}
          />
        </CardBody>
      </Card>
    </>
  );
}

export default CapabilitySetSettings;
